import { render, staticRenderFns } from "./21.vue?vue&type=template&id=f3fb02c4&scoped=true&"
var script = {}
import style0 from "./21.vue?vue&type=style&index=0&id=f3fb02c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fb02c4",
  null
  
)

export default component.exports